import { auth } from "@Firebase/firebase";
import axios from "axios";
import { CurrentUser } from "src/App";

export const sendVerifyEmail =
  (): ((request: { firebaseUser: CurrentUser }) => Promise<string>) =>
  async (request) => {
    const token = await auth.currentUser?.getIdToken();

    const response = await axios.post(
      `${process.env.REACT_APP_HTTP_URL}/lender-api/send_verify_email/`,
      request,
      {
        headers: {
          authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data.result;
  };
